export default {
  downtimeUrl: "https://id2.kodland.tech",
  startPage: {
    image: "/welcome/quiz_indo_give_away_pk.png",
    imageMobile: "/quiz_indo_give_away_mobi.png",
    title: "Kelas gratis pembuatan kartun untuk anak dan gratis belajar selama setahun? Mudah, kok!",
    subtitle:
      "Daftar kelas trial dan ikuti undian BELAJAR SATU TAHUN! Pengumuman pemenang akan dilakukan pada tanggal 20 Februari! Segera daftar! Penawaran terbatas, lho!",
    button: "Ikuti🚀",
  },
  successPage: {
    title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran 🚀 GRATIS 🚀",
    subtitle: "Klik tombol “📆 Pesan” dan dapatkan pelajarannya.",
    button: "📆 Pesan",
  },
  quizRotateBySteps: {
    1: {
      question: "Apa mata pelajaran kesukaan anak Anda?",
      answers: [
        "🔬 Sains",
        "🎨 Seni dan desain",
        "💻 Ilmu komputer",
        "🏛️ Ilmu budaya (Sejarah, Literasi, dsb.)",
        "📐 Matematika",
        "💬 Ilmu Bahasa",
        "🤩 Semua yang di atas",
      ],
    },
    2: {
      question: "Bagaimana biasanya anak Anda menghabiskan waktu luangnya?",
      answers: [
        "📱 Bermain game di HP atau komputer",
        "👽 Menonton kartun",
        "♟️ Bermain permainan papan",
        "👨‍👩‍👧‍👦 Menghabiskan waktunya dengan keluarga",
        "👥 Menghabiskan waktunya dengan teman",
        "⛹️ Bermain kegiatan olahraga",
        "🎨 Melakukan aktivitas seni: menggambar, musik, akting, dsb.",
      ],
    },
    3: {
      question: "Apakah anak Anda mengikuti kegiatan ekstrakurikuler di luar pembelajaran sekolah?",
      answers: [
        "📚 Kelas yang membantu untuk meningkatkan nilai pembelajara",
        "⛹️ Ya. Kegiatan olahraga",
        "🎨 Ya. Kelas seni",
        "💻 Ya. Kelas koding dan ilmu komputer",
        "🏕️ Ya. Pramuka",
        "✖️ Tidak. Anak tidak memiliki waktu untuk itu",
      ],
    },
  },
};

